import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { NavDropdown } from 'react-bootstrap';
import { FaUser, FaUserTie, FaUserCheck, FaDownload } from 'react-icons/fa';
import './UploadAvatar.css'; // Your custom styles
import logoImage from './NRDRUHSLogo.png'; // Import the logo image
import NRDRUHSHeader from './NRDRUHSHeader'
import NRDRUHSFooter from './NRDRUHSFooter';
import { Helmet } from 'react-helmet';

function CurrentIssue() {
    const [showMenu, setShowMenu] = useState(false);
    const [scrolling, setScrolling] = useState(false);

    const toggleMenu = () => {
        setShowMenu(prev => !prev);
    };

    useEffect(() => {
        const handleScroll = () => {
            setScrolling(window.scrollY > 50);
        };
        window.addEventListener('scroll', handleScroll);
        return () => window.removeEventListener('scroll', handleScroll);
    }, []);

    return (
        <div>
            {/* NAVBAR */}
            <nav className={`navBar ${scrolling ? 'scrolling' : ''}`} data-aos="fade-down" data-aos-duration="1200">
                {/* Logo Image */}
                <img src={logoImage} alt="Logo" className="logo" />

                {/* Hamburger Menu Button */}
                <div className="menuButton" onClick={toggleMenu}>
                    <div className={`menuIcon ${showMenu ? 'open' : ''}`} />
                </div>

                {/* Navigation Links */}
                <ul className={`navLinks ${showMenu ? 'show' : ''}`}>
                    <li><Link to="/" className="link">Home</Link></li>
                    <li><Link to="/aboutus" className="link">About NRD</Link></li>
                    <li><Link to="/issnpage" className="link">ISSN</Link></li>
                    <li><Link to="/editorialboard" className="link">Editorial Board</Link></li>
                    <li><Link to="/currentissue" className="link">Current Issue</Link></li>
                    <li><Link to="/publications" className="link">Publications</Link></li>

                    <NavDropdown title="Login" id="basic-nav-dropdown" style={{ fontWeight: 'bold' }}>
                        <NavDropdown.Item href="/login">
                            <FaUser style={{ marginRight: 6, color: 'Navy' }} /> Author
                        </NavDropdown.Item>
                        <NavDropdown.Item href="/reviewlogin">
                            <FaUserTie style={{ marginRight: 6, color: 'Chocolate' }} /> Reviewer
                        </NavDropdown.Item>
                        <NavDropdown.Item href="/adminlogin">
                            <FaUserCheck style={{ marginRight: 6, color: 'green' }} /> Admin
                        </NavDropdown.Item>
                    </NavDropdown>
                </ul>

                {/* Register Dropdown */}
                <NavDropdown title="Register" id="register-dropdown" style={{ fontWeight: 'bold', marginRight: 18, backgroundColor: 'red', padding: 15 }}>
                    <NavDropdown.Item href="/register">
                        <FaUser style={{ marginRight: 6, color: 'Navy' }} /> As an Author
                    </NavDropdown.Item>
                    <NavDropdown.Item href="/registerreviewer">
                        <FaUserTie style={{ marginRight: 6, color: 'red' }} /> As a Reviewer
                    </NavDropdown.Item>
                </NavDropdown>
            </nav>

            <NRDRUHSHeader />

            {/* ISSN Content */}
            <div>
                <Helmet>
                    <title>Current Issue – NRD RUHS Articles Portal</title>
                    <meta name="description" content="View the latest issue of NRD RUHS Articles Journal with published research and medical articles." />
                    <link rel="canonical" href="https://nrdruhs.in/currentissue" />
                </Helmet>

                {/* Main Content Section */}
                <div className="current-issue-container" style={{ textAlign: 'center', marginTop: '40px', marginBottom: 180 }}>
                    <h2 style={{ marginTop: 60, marginBottom: 60 }}>Current Issue - NRD RUHS Vol 14 Issue 4 (Oct-Dec 2025)</h2>

                    <img
                        src="https://nrdruhs.in/uploads/NRDRHUSPublicationNewVol14No4.jpg"
                        alt="Current Issue Image"
                        className="current-issue-image"
                        style={{
                            width: '18%',
                            margin: '0 auto',
                            cursor: 'pointer',
                            border: '1px solid lightgrey', // Light grey border added
                            borderRadius: '4px' // Optional: smooth corners for better visual
                        }}
                        onClick={() =>
                            window.open(
                                'https://nrdruhs.in/uploads/ARTICLES-MERGED-OCT-DEC-2025-VOL-14-ISSUE-4.pdf',
                                '_blank'
                            )
                        }
                    />




                    <div className="text-center" style={{ marginTop: 60 }}>
                        <a
                            href="https://nrdruhs.in/uploads/ARTICLES-MERGED-OCT-DEC-2025-VOL-14-ISSUE-4.pdf"
                            className="btn btn-primary"
                            rel="noopener noreferrer"
                            download="ARTICLES-MERGED-JUL-SEP-2024-VOL-13-ISSUE-3.pdf"
                            style={{ width: '200px', display: 'inline-block' }}  // Fix the width and display inline-block for centering
                        >
                            <i className="fa fa-download" style={{ marginRight: '10px' }}></i> {/* Custom margin for space between icon and text */}
                            Download PDF
                        </a>
                    </div>




                </div>
            </div>

            <NRDRUHSFooter />
        </div>
    );
}

export default CurrentIssue;
